import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import http from "./sitel/commons/services/http";
import log from "./sitel/commons/services/log";
import authCentral from "./services/authCentral";
import auth from "./sitel/demon/services/auth";
import App from './App';
import "./sitel/demon/ui/demon.css";

//INIT THE APP can be from env or hard coded
log.init.setLogHandler(process.env.REACT_APP_LOG_HANDLER);
log.init.setLogLevel(process.env.REACT_APP_LOG_LEVEL);
http.setAppApiBaseUrl(process.env.REACT_APP_API_ENDPOINT);
http.setLogoutCallback(authCentral.localLogout);
authCentral.setTokenKeyName(process.env.REACT_APP_AUTH_TOKEN_NAME);
auth.setTokenKeyName(process.env.REACT_APP_AUTH_TOKEN_NAME);
authCentral.setOauth(
    process.env.REACT_APP_OAUTH_CLIENT_ID,
    process.env.REACT_APP_OAUTH_SERVER_URL,
    process.env.REACT_APP_OAUTH_REDIRECT_URI,
    process.env.REACT_APP_OAUTH_SCOPES,
    process.env.REACT_APP_OAUTH_LOGOUT_URL
);
const baseName = "/central";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename={baseName}>
        <App basename={baseName} />
    </BrowserRouter>
);
